export default {
  whatsappProfile: state => state.whatsappProfile,
}
